import { useQuery } from "@apollo/react-hooks";

import { FranchiseAgreementData } from "../types";
import QueryForAcceptanceData from "../graph-ql/QueryForAcceptanceData.graphql";

const useQueryForAcceptanceData = (input: {
  agreementKey: string;
  onCompleted?: () => void;
  onError?: () => void;
}) =>
  useQuery<FranchiseAgreementData>(QueryForAcceptanceData, {
    variables: { agreementKey: input.agreementKey },
    onCompleted: input.onCompleted,
    onError: input.onError,
  });

export default useQueryForAcceptanceData;
